import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  template: `
    <app-loading-screen [contrast]="true"></app-loading-screen>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrgChartsSocCompatibilityComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  public async ngOnInit(): Promise<void> {
    this.redirectToOrgManagement(await this.convertQueryParams());
  }

  private async convertQueryParams(): Promise<Params> {
    const socQueryParams = this.activatedRoute.snapshot.queryParams;
    const convertedQueryParams: Params = {};

    if (socQueryParams?.organizationUniqueName) {
      convertedQueryParams.orgCode = socQueryParams.organizationUniqueName;

      if (socQueryParams?.userUniqueName) {
        convertedQueryParams.employeeGid = socQueryParams.userUniqueName;
        convertedQueryParams.employeeOrgCode = socQueryParams.organizationUniqueName;
      }
    }

    return convertedQueryParams;
  }

  private redirectToOrgManagement(queryParams: Params): void {
    this.router.navigate(['org-management'], { queryParams });
  }
}
